import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {EnvironmentModel} from "../../BaseEnvironments/Model";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {CrudMenuItem} from "../../Utility/Utility";
import {Progetto} from "../../../app/Progetti/Models/Progetto";
import {ToastrService} from "ngx-toastr";
import {Permission} from "../../../app/Login/_guards/Permission";
import {ProgettoComponent} from "../../../app/Progetti/progetto/progetto.component";

function Vettori() {
  var OBJ: OggettoConfig = {
    Id: "vettori",
    MenuItems: [
      CrudMenuItem("vettori", "fas fa-truck-loading", "Vettori Zone" )
    ],
    RestRoute:'/anagrafica/zone',
    ListResponseHasData:true,
    HasGet:false,
    Headers:[
      CampoAggiuntivo.TextField("Vettore", "vettoreObject.vettore", "col-12", {modificabile:false}),
      CampoAggiuntivo.TextField("Zona", "nome", "col-12", {modificabile:false}),
      CampoAggiuntivo.TextField("Codice", "codice", "col-12", {modificabile:false}),
    ],
    campi:[
      CampoAggiuntivo.TextField("Zona", "nome", "col-12", {modificabile:false}),
      CampoAggiuntivo.SingleDropdown("Vettore", "id_vettore", '/anagrafica/clienti/vettori', 'vettore', {internalOutput: `vettoreObject`,},'col-lg-3',()=>true, {selectIfSingle:false})
    ]
  }
  return OBJ;
}


export var VettoriEnv = () => {
  var env: EnvironmentModel = {
    Modules: {
      "Vettori": true
    },
    ClientiAddOn:{
      CampiAggiuntivi:[
        CampoAggiuntivo.SingleDropdown("Vettore", "vettore", '/anagrafica/clienti/vettori', 'vettore', {},'col-lg-3')
      ]
    },
    ProdottiAddOn: {
      CampiAggiuntivi:[
        CampoAggiuntivo.SingleDropdown("Vettore", "vettore", '/anagrafica/clienti/vettori', 'vettore', {},'col-lg-3')
      ]
    },
    Cruds: [Vettori()],
    Menu: [...Vettori().MenuItems]
  }
  return env;

}

export function AggVettoreOrdine(progetto: any, InitialValue: Progetto, toast: ToastrService, permission: Permission, component: ProgettoComponent) {
  if(progetto?.progetti?.some(x => x.vettore))return;
  /*
  * - In base alle dimensioni del prodotto, ci sono alcuni che hanno delle dimensioni che necessitano un vettore particolare, quindi se presente in ordine uno di questi prodotti deve essere selezionato il vettore specifico.
    - impostato sull’ordine, es. tutti gli ordini Sanpellegrino devo partire con FERCAM oppure selezionato dal Commerciale
    - impostato su anagrafica cliente;
    - Zona, quindi a livello di provincia / Regione
  *
  *
  * */

  var isKeyaccountOrder = progetto.oggetto?.toLowerCase() == 'sanpellegrino'

  var vettoreCliente = progetto.clienteObject?.vettoreObject;
  var vettoreKeyaccount = isKeyaccountOrder ? (progetto?.clienteObject?.keyaccountObject?.reduce((prev, cur)=>[...prev, cur.vettoreObject],[])?.filter(x => x?.id) ?? []) : [];
  var vettoriProdotto = progetto?.progetti?.reduce((prev, cur) => [...prev, ...cur.voci?.map(x => x?.vettoreObject?? x?.prodottoObject?.vettoreObject ?? x.Prodotto?.vettoreObject)], [])?.filter(x => x?.id) ?? [];
  var vettoreZona = progetto.clienteObject?.zona ? component.vettori.find(x => x.id === progetto.clienteObject?.zona)?.vettoreObject : null;
  console.log("Vettori Prodotti",vettoriProdotto);
  console.log("Vettore Cliente",vettoreCliente);
  console.log("Vettore Keyaccount",vettoreKeyaccount);
  console.log("Vettore Zona",vettoreZona);

  var vettori = [...new Set([...vettoriProdotto.map(x=>({...x, Priorita: 1})), ...vettoreKeyaccount.map(x=>({...x, Priorita: 2})), {...vettoreCliente ?? {}, Priorita: 3}, {...vettoreZona ??{}, Priorita: 4}])].filter(x => x?.id);
  console.log("Vettori",vettori);
  function getMinPriorityItems<T extends { Priorita: number }>(items: T[]): T[] {
    let min = Infinity;
    const result: T[] = [];

    for (const item of items) {
      if (item.Priorita < min) {
        min = item.Priorita;
        result.length = 0;
        result.push(item);
      } else if (item.Priorita === min) {
        result.push(item);
      }
    }

    return result;
  }
  const vettoriDefault = getMinPriorityItems(vettori);
  console.log("vettori prioritari",vettoriDefault);
  if(vettoriDefault?.length)
  progetto.progetti?.forEach(x => {
    x.vettoreObject = vettoriDefault[0];
  })



}
